import React from 'react';
import TopBanner from './TopBanner';

export const NoContentForNow = () => {
  
    return (
        <>
          <TopBanner 
            bgimage='/images/blogs/construction.gif'  // Updated to use the public folder path
            title="Thank you for visiting our site. This content is currently in construction."
          />
        </>
    );
};
